import React, { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, ContratosReducer, ContratosState } from "./contratos-reducer";
import { PaginationResponse } from "models/pagination-response";
import { IContratoPagedResponse } from "models/response/contrato-paged-response";

const ContratosContext = createContext<ContratosState | undefined>(undefined);
const ContratosContextDispatchContext = createContext({} as any);

const ContratosProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(ContratosReducer, {
        contratos: new PaginationResponse<IContratoPagedResponse>([], 0, 1, 10, 0),
        contratoPagedRequest: { page: 0, pageSize: 10 },
        tipos: [],
        situacoes: [],
        ultimaAtualizacao: null,
        loading: false,
        error: null
    } as ContratosState);

    return (
        <ContratosContext.Provider value={state}>
            <ContratosContextDispatchContext.Provider value={dispatch}>
                {children}
            </ContratosContextDispatchContext.Provider>
        </ContratosContext.Provider>
    );
}

const useContratosState = () => {
    const context = useContext(ContratosContext);
    if (context === undefined) {
        throw new Error('useContratosState must be used within a ContratosProvider');
    }
    return context;
}

const useContratosDispatch = () => {
    const context = useContext(ContratosContextDispatchContext);
    if (context === undefined) {
        throw new Error('useContratosDispatch must be used within a ContratosProvider');
    }
    return context;
}

export { ContratosProvider, useContratosState, useContratosDispatch, ACTION_TYPES };
